import { Box, Stack, Modal, Button } from '@mui/material';
import { useCallback, useRef } from 'react';
import Webcam from 'react-webcam';

const ProfileTakePhotoModal = ({
  isOpen,
  onClose,
  onCapture,
}: {
  isOpen: boolean;
  onClose: () => void;
  onCapture: (fileData: File, fileUrl: string, fileName: string) => void;
}) => {
  const webcamRef = useRef<typeof Webcam>(null);

  const capture = useCallback(() => {
    if (webcamRef.current) {
      const imageSrc = webcamRef.current.getScreenshot();
      if (imageSrc) {
        const timestamp = Date.now();
        const generatedFileName = `captured_${timestamp}.png`;

        fetch(imageSrc)
          .then((res) => res.blob())
          .then((blob) => {
            const mockFile = new File([blob], generatedFileName, {
              type: 'image/png',
              lastModified: new Date().getTime(),
            });
            onCapture(mockFile, imageSrc, generatedFileName);
            onClose();
          })
          .catch((error) => {
            console.error('Error creating mockFile:', error);
          });
      }
    } else {
      console.warn('Webcam is not available.');
    }
  }, [webcamRef, onCapture]);

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '80%',
          maxWidth: 600,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          outline: 0,
        }}
      >
        <Stack spacing={2} alignItems='center'>
          <Webcam
            audio={false}
            ref={webcamRef}
            screenshotFormat='image/jpeg'
            style={{
              width: '100%',
              maxHeight: 400,
              // transform: 'scaleX(-1)'
            }}
          />
        </Stack>
        <Box mb={2} />
        <Stack
          direction='row'
          gap={1}
          justifyContent='flex-end'
          alignItems='right'
        >
          <Button
            sx={{
              width: '100px',
              height: '35px',
              border: '1px solid',
              backgroundColor: 'transparent',
            }}
            onClick={onClose}
          >
            Close
          </Button>
          <Button
            onClick={capture}
            variant='contained'
            sx={{
              width: '100px',
              height: '35px',
            }}
          >
            Capture
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default ProfileTakePhotoModal;
